
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { motion } from "framer-motion";

interface RefreshButtonProps {
  isLoading: boolean;
  onRefresh: () => void;
}

export function RefreshButton({ isLoading, onRefresh }: RefreshButtonProps) {
  return (
    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
      <Button 
        variant="outline" 
        size="sm" 
        className="flex items-center gap-2 metal-border hover:bg-metal/10 transition-colors"
        onClick={onRefresh}
        disabled={isLoading}
      >
        <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} /> 
        {isLoading ? 'Aggiornamento...' : 'Aggiorna'}
      </Button>
    </motion.div>
  );
}
